export default class PrinterLightsV2 {
	constructor() {
		this.blockName = "PrinterLightsV2";

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		// $(element).find('.control-selector__items-container > span').on('click', (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element);
			
		blocks.add({
			name: this.blockName,
			version: '2',
			passes: [this.addPasses()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				offset: { Y: 0, R: 0, G: 0, B: 0 },
			},
		});

		this.slidersInit($(element));
	}

	addPasses() {
		let shaderPass = gpu.createLiftGammaGainPass();
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			change: (event, ui) => this.verticalSliderHandler(event, ui),
			slide: (event, ui) => this.verticalSliderHandler(event, ui),
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	verticalSliderHandler(event, ui) {
		let $sliderControlElement = $(event.target);
		let controlName = $sliderControlElement.data("curve").split("-")[0];
		let controlCurve = $sliderControlElement.data("curve").split("-")[1];

		lutify.getActiveBlock().values.offset[controlCurve] = ui.value;
		lutify.getActiveBlock().passes[0].enabled = true;

		lutify.getActiveBlock().passes[0].uniforms.offset.value.x = lutify.getActiveBlock().values.offset.R;
		lutify.getActiveBlock().passes[0].uniforms.offset.value.y = lutify.getActiveBlock().values.offset.G;
		lutify.getActiveBlock().passes[0].uniforms.offset.value.z = lutify.getActiveBlock().values.offset.B;
		lutify.getActiveBlock().passes[0].uniforms.offset.value.w = lutify.getActiveBlock().values.offset.Y;

		gpu.render();

		let $sliderInputElement = $sliderControlElement.closest('.control-container').find(`.slider-input-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderInputElement.val(ui.value);

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));
	}

	verticalSliderInputHandler($sliderInputElement) {
		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		lutify.getActiveBlock().values[controlName][controlCurve] = $sliderInputElement.val();

		let $sliderControlElement = $sliderInputElement.closest('.control-container').find(`.slider-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderControlElement.slider("value", $sliderInputElement.val());

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	resetBlock($element) {
		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetVerticalSlider($slider) {
		$slider.slider("value", 0);
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		Object.keys(values).forEach(control => {
			$block
				.find(`.block-controls-container .slider-input-control[data-curve="${control}-Y"]`)
				.val(values[control].Y)
			$block
				.find(`.block-controls-container .slider-input-control[data-curve="${control}-R"]`)
				.val(values[control].R)
			$block
				.find(`.block-controls-container .slider-input-control[data-curve="${control}-G"]`)
				.val(values[control].G)
			$block
				.find(`.block-controls-container .slider-input-control[data-curve="${control}-B"]`)
				.val(values[control].B)
		});

		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
